import { BaseMap } from '../../../types';

// 缓存已加载的图片，使用 URL 作为键
const imageCache = new Map<string, HTMLImageElement>();

/**
 * 渲染底图（在世界坐标系中）
 * 注意：此函数应该在应用了zoom和offset变换后调用
 */
export function renderBaseMap(
  ctx: CanvasRenderingContext2D,
  baseMap: BaseMap
): void {
  if (!baseMap.visible) return;

  // 使用 imageData (URL) 作为缓存键，而不是 id
  const cacheKey = baseMap.imageData;
  let img = imageCache.get(cacheKey);

  if (!img) {
    img = new Image();
    img.src = baseMap.imageData;
    imageCache.set(cacheKey, img);
    
    console.log('🗺️ 开始加载底图:', baseMap.imageData);
    
    // 如果图片还未加载完成，下一帧会继续尝试
    if (!img.complete) {
      return;
    }
  }

  // 图片未加载完成
  if (!img.complete) {
    return;
  }

  ctx.save();

  // 设置透明度
  ctx.globalAlpha = baseMap.opacity;

  // 底图在世界坐标系中的位置和大小
  // 使用baseMap.scale来确定1像素对应多少世界单位
  // 默认scale=100表示100像素=1米=100世界单位
  const worldWidth = baseMap.width * (100 / baseMap.scale);
  const worldHeight = baseMap.height * (100 / baseMap.scale);

  // 应用底图自身的偏移
  const worldX = baseMap.offset.x;
  const worldY = baseMap.offset.y;

  // 应用旋转（如果有）
  if (baseMap.rotation !== 0) {
    const rotCenterX = worldX + worldWidth / 2;
    const rotCenterY = worldY + worldHeight / 2;
    ctx.translate(rotCenterX, rotCenterY);
    ctx.rotate(baseMap.rotation);
    ctx.translate(-rotCenterX, -rotCenterY);
  }

  // 绘制图片（在世界坐标系中）
  ctx.drawImage(img, worldX, worldY, worldWidth, worldHeight);

  // 绘制提示边框
  ctx.globalAlpha = 0.3;
  ctx.strokeStyle = '#3b82f6';
  ctx.lineWidth = 2 / ctx.getTransform().a; // 保持线宽不随缩放变化
  ctx.setLineDash([10 / ctx.getTransform().a, 5 / ctx.getTransform().a]);
  ctx.strokeRect(worldX, worldY, worldWidth, worldHeight);
  ctx.setLineDash([]);

  ctx.restore();
}

/**
 * 清除图片缓存
 */
export function clearImageCache(): void {
  imageCache.clear();
}

/**
 * 移除特定图片的缓存
 */
export function removeImageFromCache(imageData: string): void {
  imageCache.delete(imageData);
}
